import { GAME_MOVED, SEE_GAME, SET_GAMES_WITH_NEW_MOVES } from './constants';

/** The other player moved in one of your games (the server's GameMoved, on your own channel). */
export const gameMoved = ({ gameId, version, gamesWithNewMoves }) => ({
  type: GAME_MOVED,
  payload: { gameId, version, gamesWithNewMoves },
});

/** You've seen the game up to this version. */
export const seeGame = (gameId, version) => ({ type: SEE_GAME, payload: { gameId: Number(gameId), version } });

export const setGamesWithNewMoves = (count) => ({ type: SET_GAMES_WITH_NEW_MOVES, payload: count });
